import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BlockEmptyNews from '../../components/BlockEmptyNews';
import FilterNews from '../../components/FilterNews';
import MainHeaderLinks from '../../components/MainHeaderLinks';
import MainPageFooter from '../../components/MainPageFooter';
import NewsBlock from '../../components/NewsBlock';
import { requestGetMoreNews } from '../../redux/actions/main-page';
import { RootState } from '../../redux/reducers/rootReducer';
import { getInform } from '../../utils/constants/get-news-inform';
// import BlockEmptyNews from '../../components/BlockEmptyNews';
import { SEO } from '../../utils/constants/seo';
import { INewOnPageResponse, INewsInformationResponses } from '../../utils/types/admin-types';
import { useDocumentSeo } from '../../utils/useDocumentSeo';
import Page404 from '../Page404/Page404';
import classes from './news.module.scss';

function News() {
  const news = useSelector<RootState, INewOnPageResponse >(
    (state) => state.newsReducer.responses,
  );
  const infoDivision = useSelector<RootState, INewsInformationResponses >(
    (state) => state.newsDivisionReducer.responses,
  );

  const dispath = useDispatch();
  const NextPage = () => {
    dispath(requestGetMoreNews({ nextPage: (news.next) !== null ? news.next.split('?')[1] : null }));
  };

  useDocumentSeo(SEO.news);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (true) {
    return <Page404 />;
  }

  return (
    <div className={classes.container}>
      <MainHeaderLinks colored isSticked />
      <div className={classes.newsBlock}>
        <div className={classes.title}>
          <h2>Новости</h2>
        </div>
        <FilterNews />
        {getInform(infoDivision).length === 0
          ? <BlockEmptyNews />
          : <NewsBlock />}
        {news.next !== null && news.count !== 0 && getInform(infoDivision).length !== 0
          ? (
            <div role="none" className={classes.button} onClick={NextPage}>
              <p>
                Больше новостей
              </p>
            </div>
          )
          : null}
      </div>

      <MainPageFooter />
    </div>
  );
}

export default memo(News);
